
/** @format */
import React, { useState, useEffect } from 'react';
import { Grid, CircularProgress } from '@mui/material';
import { SimpleDialog, ButtonLoading, Icons } from 'components';
import TextItemDotted from '../../../components/TextItemDotted';
import { useStyles } from '../style';
import Services from '../../../services/Services';
import { useNavigate } from 'react-router-dom';
const CreateSignature = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { result } = props;
  const [isLoadingPdf, setIsLoadingPdf] = useState(false);
  const [isOpenRetryDG, setIsOpenRetryDG] = useState(false);
  const [isloadProgress, setIsLoadProgress] = useState(false);


  const checkValue = {
    'false': 0,
    'true': 1,
  }
  useEffect(() => {
    if (result?.source?.isClosed === false &&
      result?.source?.error?.hasError === true &&
      result?.source?.warrantyStatus === 'ERROR' &&
      result?.source?.warrantyStep === 'SIGNATURE_CONTRACT' &&
      result?.source?.warrantySubStep === 'BANK_SIGNATURE'
    ) {
      setIsOpenRetryDG(true)
    }
    //result && setIsSignature(result?.source?.contract?.signatoriesStatus)
  }, [result])

  const retryRequest = async () => {
    setIsLoadProgress(true)
    const param = {
      'entity-id': result?.source?.entityId,
      'warrantySubStep': result?.source?.warrantySubStep,
    };
    Services.postWarrantiesRetry(result?.source?.entityId, param)
      .then((res) => {
        setIsLoadProgress(false);
        createToast('موفق', 'درخواست مجدد با موفقیت انجام شد', 'success');
        navigate('/Warranty/RequestList')
      })
      .catch((error) => {
        setIsLoadProgress(false);

      });
  };

  const onDownloadPdf = async () => {
    try {
      setIsLoadingPdf(true);
      await Services.getExpertRequests(result?.source?.entityId);
    } catch (error) {

    } finally {
      setIsLoadingPdf(false);
    }
  }

  return (
    <>
      {result ? (
        <Grid container direction="row" alignItems="center" spacing={0} item xs={12}>
          {/* وضعیت   با موفقیت   */}
          {result?.source?.warrantyStep !== 'REGISTER_CONTRACT' &&
            result?.source?.warrantyStep !== 'SIGNATURE_CONTRACT' ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات ایجاد و امضا قرارداد</h3>
              </Grid>
              {
                <>
                  <TextItemDotted
                    title="شماره قرارداد "
                    title2={result?.source?.contract?.contractNumber}
                  />
                  <TextItemDotted
                    title="تاریخ ایجاد"
                    title2={result?.source?.contract?.contractDate}
                    isDate={true}
                  />

                  <TextItemDotted
                    title="وضعیت امضا داران"
                    isBadgeSuccess={result?.source?.contract?.signatoriesStatus}
                    title2={'تایید شد'}
                  />

                  <TextItemDotted
                    title="  وضعیت امضا بانک"
                    isBadgeSuccess={true}
                    title2={'تایید شد'}
                  />


                </>
              }
              <Grid className={classes.blockCardFooter}>
                <h3 className={classes.blockCardFooterTitle}>

                  ایجاد و امضا قرارداد با موفقیت انجام شد.
                </h3>
              </Grid>
            </Grid>
          ) : (
            ''
          )}
          {/* وضعیت منقضی شده*/}
          {(result?.source?.warrantyStep === 'REGISTER_CONTRACT' ||
            result?.source?.warrantyStep === 'SIGNATURE_CONTRACT') &&
            result?.source?.warrantyStatus === 'EXPIRED' ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات ایجاد و امضا قرارداد</h3>
              </Grid>
              {
                <>
                  <TextItemDotted
                    title="شماره قرارداد "
                    title2={result?.source?.contract?.contractNumber}
                  />
                  <TextItemDotted
                    title="تاریخ ایجاد"
                    title2={result?.source?.contract?.contractDate}
                    isDate={true}
                  />

                </>
              }

              <Grid className={classes.blockCardFooter}>
                <h3 className={classes.blockCardFooterTitle}>
                  درخواست صدور ضمانت نامه منقضی شده است
                </h3>
              </Grid>
            </Grid>
          ) : ('')}

          {/* وضعیت در انتظار */}
          {result?.source?.warrantyStep === 'REGISTER_CONTRACT' &&
            result?.source?.warrantyStatus === 'WAITING' ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات ایجاد و امضا قرارداد</h3>
              </Grid>
              <Grid className={classes.blockCardFooter}>
                <h3 className={classes.blockCardFooterTitle}>
                  قرارداد در حال ثبت  می باشد.
                </h3>
              </Grid>
            </Grid>

          ) : ('')}

          {/* وضعیت در انتظار */}
          {result?.source?.warrantyStep === 'SIGNATURE_CONTRACT' &&
            result?.source?.warrantyStatus === 'WAITING' ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات ایجاد و امضا قرارداد</h3>
              </Grid>
              {
                <>
                  <TextItemDotted
                    title="شماره قرارداد "
                    title2={result?.source?.contract?.contractNumber}
                  />
                  <TextItemDotted
                    title="تاریخ ایجاد"
                    title2={result?.source?.contract?.contractDate}
                    isDate={true}
                  />
                  <TextItemDotted
                    title="وضعیت امضا داران"
                    isBadgeSuccess={checkValue[JSON.stringify(result?.source?.contract?.signatoriesStatus)] == 1 ? true : false}
                    isBadgeWarning={checkValue[JSON.stringify(result?.source?.contract?.signatoriesStatus)] == 1 ? false : true}
                    title2={checkValue[JSON.stringify(result?.source?.contract?.signatoriesStatus)] == 1 ? 'تایید شد' : 'در انتظار'}
                  />
                  <TextItemDotted
                    title=" وضعیت امضا بانک"
                    isBadgeWarning={true}
                    title2={'در انتظار'}
                  />

                </>
              }
              <Grid className={classes.blockCardFooter}>
                <h3 className={classes.blockCardFooterTitle}>
                  {checkValue[JSON.stringify(result?.source?.contract?.signatoriesStatus)] === 1 ? 'قرارداد در انتظار امضا بانک می باشد. ' : 'قرارداد در انتظار امضا نمایندگان می باشد.'}
                </h3>
              </Grid>
            </Grid>
          ) : ('')}

          {/* وضعیت رد شده  */}
          {((result?.source?.warrantyStep === 'REGISTER_CONTRACT' ||
            result?.source?.warrantyStep === 'SIGNATURE_CONTRACT'
          ) &&
            (result?.source?.warrantyStatus === 'INCOMPLETE' ||
              result?.source?.warrantyStatus === 'REJECTED')) ? (
            <Grid className={classes.blockCard}>
              <Grid className={classes.blockCardHeader}>
                <h3 className={classes.blockCardTitle}>جزئیات ایجاد و امضا قرارداد</h3>
              </Grid>

              {
                <>
                  {!result?.source?.contract?.contractResultDesc ? (
                    <>
                      <TextItemDotted
                        title="شماره قرارداد "
                        title2={result?.source?.contract?.contractNumber}
                      />
                      <TextItemDotted
                        title="تاریخ ایجاد"
                        title2={result?.source?.contract?.contractDate}
                        isDate={true}
                      />
                    </>
                  ) : (null)}
                  {result?.source?.contract?.contractResultDesc ? (
                    <>
                      <TextItemDotted
                        title="دلیل رد ایجاد و امضا قرارداد "
                        title2=''
                        type="desc"
                      />

                      <TextItemDotted
                        title=""
                        title2={result?.source?.contract?.contractResultDesc}
                        type="desc"
                      />
                    </>
                  ) : (
                    <>
                      <TextItemDotted
                        title="وضعیت امضا داران"
                        isBadgeSuccess={checkValue[JSON.stringify(result?.source?.contract?.signatoriesStatus)] == 1 ? true : false}
                        isBadgeDanger={checkValue[JSON.stringify(result?.source?.contract?.signatoriesStatus)] == 1 ? false : true}
                        title2={checkValue[JSON.stringify(result?.source?.contract?.signatoriesStatus)] == 1 ? 'تایید شد' : 'تایید نشد'}
                      />
                      {result?.source?.contract?.signatoriesStatus ? (
                        <TextItemDotted
                          title=" وضعیت امضا بانک"
                          isBadgeSuccess={checkValue[JSON.stringify(result?.source?.contract?.banksignatoriesStatus)] == 1 ? true : false}
                          isBadgeDanger={checkValue[JSON.stringify(result?.source?.contract?.banksignatoriesStatus)] == 1 ? false : true}
                          title2={checkValue[JSON.stringify(result?.source?.contract?.banksignatoriesStatus)] == 1 ? 'تایید شد' : 'تایید نشد'}
                        />
                      ) : (
                        null
                      )}
                    </>
                  )}

                </>
              }
              <Grid className={classes.blockCardFooter}>
                <h3 className={classes.blockCardFooterTitle}> ایجاد و امضا قرارداد رد شد.</h3>
              </Grid>
            </Grid>
          ) : (
            ''

          )}

          {/* وضعیت خطا*/}
          {
            result?.source?.error?.hasError === true &&
              result?.source?.warrantyStatus === 'ERROR' &&
              result?.source?.warrantyStep === 'SIGNATURE_CONTRACT' &&
              result?.source?.warrantySubStep === 'BANK_SIGNATURE'
              ? (
                <Grid className={classes.blockCard}>
                  <Grid className={classes.blockCardHeader}>
                    <h3 className={classes.blockCardTitle}>جزئیات ایجاد و امضا قرارداد</h3>
                  </Grid>
                  {
                    <>
                      <TextItemDotted
                        title="شماره قرارداد "
                        title2={result?.source?.contract?.contractNumber}
                      />
                    </>
                  }

                  <Grid className={classes.blockCardFooter}>
                    <h3 className={classes.blockCardFooterTitle}>
                      درخواست با خطا مواجه شده است.
                    </h3>
                  </Grid>
                </Grid>
              ) : ('')}

          {result?.source?.contract?.contractNumber ? (
            <Grid className={classes.blockDownload}>
              <ButtonLoading
                color="primary"
                variant="outlined"
                name={
                  <>
                    <span style={{ marginLeft: '5px', marginTop: '8px', opacity: isLoadingPdf ? '0.3' : '1' }}><Icons icon="ReceiveSquare" color="#2b3990" size="23" /></span>
                    دریافت متن قرارداد ضمانت‌نامه
                  </>
                }
                loading={isLoadingPdf}
                onClick={onDownloadPdf}
                className={classes.buttonAction}
              />
            </Grid>
          ) : (
            ''
          )}

          <SimpleDialog
            onClose={() => setIsOpenRetryDG(false)}
            fullWidth maxWidth="sm" open={isOpenRetryDG} title="خطا در ایجاد و امضا قرارداد">
            <Grid container style={{ textAlign: 'justify' }}>
              <p style={{ margin: '20px 0' }}>
                {result?.source?.error?.message}
              </p>
            </Grid>
            <Grid style={{ display: 'flex', marginTop: '16px', flexDirection: 'row-reverse' }}>

              <ButtonLoading
                type="submit"
                variant="contained"
                color="primary"
                loading={isloadProgress}
                name=" درخواست مجدد"
                onClick={() => retryRequest()}
              />
            </Grid>
          </SimpleDialog>
        </Grid>
      ) : (
        result?.length !== 0 ? (
          <div className={classes.loadingFinger}>
            <CircularProgress color="inherit" size={30} />
          </div>
        ) : (
          ''
        )
      )
      }
    </>
  );
};

export default CreateSignature;
